import { StatusCodes } from 'http-status-codes';
import { updateAuthStatus } from 'actions/session';
import { FETCH_SOURCE } from '../constants/storeStates';
import { onGbpSessionError } from 'actions/gbp';

const apiUrl = APP_CONFIG.api.url;

export const requestHandler = (request, store) => {
    const opcoValue = store.getState().user.get('data').get('opcoId');
    const accountValue = store.getState().user.get('data').get('syscoCustomerId');
    if (opcoValue != null && accountValue != null) {
        request.headers['X-Opco-Account'] = opcoValue + '-' + accountValue;
    }
    return request;
};

export const requestErrorHandler = (error, store) => {
    return Promise.reject(error);
};

export const responseHandler = (response, store) => {
    return response;
};

export const responseErrorHandler = (error, store) => {
    const session = store.getState().session;
    const alreadySetFalse = !session.get('authenticated') && session.get('source') === FETCH_SOURCE.ACTION;

    if (
        !alreadySetFalse &&
        error.response &&
        error.response.status === StatusCodes.UNAUTHORIZED &&
        error.response.config &&
        error.response.config.url &&
        error.response.config.url.includes(apiUrl) // opt out service responses
    ) {
        store.dispatch(updateAuthStatus(false));
    }

    if (error.response.data) {
        if (error.response.data.code === 100013 || error.response.data.code === 100014) {
            store.dispatch(onGbpSessionError(true, true));
        }
    
        else if (error.response.data.code === 100009) {
            store.dispatch(onGbpSessionError(true, false));
        }
    }

    return Promise.reject(error);
};
